// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"55a13a2a","126":"bcc4ff26","173":"ce244889","236":"676f0e6b","424":"f4def4f0","434":"0824df9f","464":"83b0ad66","487":"09dab4df","689":"76b929b1","906":"031dc2c6","969":"eea193c5","978":"65c34855"}[chunkId] + ".chunk.js";
};